module.exports = __webpack_public_path__ + "img/TOP2.da28c282.png";